import DefaultTextInputStyle from './DefaultTextInput.style';

const TextInputStyles = {
  DEFAULT: DefaultTextInputStyle,
};

export type TextInputStyles = typeof TextInputStyles;

export default TextInputStyles;
